import * as React from 'react';
import {
    IAppState,
} from '../Types/Model';

const Context = React.createContext<IAppState>({} as IAppState);

export default Context;


// WEBPACK FOOTER //
// ./src/State/Context.tsx